import { A11yStatusMessageOptions } from "downshift";
import { useI18n } from "../../../i18n/i18n";
import { BaseOptionType } from "../types";

export const useA11yStatusMessages = () => {
    const { i18n } = useI18n();

    const getA11yStatusMessage = <Option extends BaseOptionType>({
        isOpen,
        resultCount,
        previousResultCount,
    }: A11yStatusMessageOptions<Option>) => {
        if (!isOpen) {
            return "";
        }

        if (!resultCount) {
            return i18n._(/*i18n*/ "No results found.");
        }

        if (resultCount !== previousResultCount) {
            return i18n._(
                /*i18n*/ {
                    id: "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.",
                    values: {
                        resultCount,
                    },
                }
            );
        }

        return "";
    };

    const getA11ySelectionMessage = <Option extends BaseOptionType>({
        selectedItem,
        itemToString: itemToStringLocal,
    }: A11yStatusMessageOptions<Option>) => {
        return selectedItem
            ? i18n._(
                  /*i18n*/ {
                      id: "{itemAsString} has been selected.",
                      values: {
                          itemAsString: itemToStringLocal(selectedItem),
                      },
                  }
              )
            : "";
    };

    return {
        getA11ySelectionMessage,
        getA11yStatusMessage,
    };
};
